import type { Message } from '../types'

function formatTimestamp(date: Date): string {
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function exportConversationAsMarkdown(
  messages: Message[],
  title?: string,
): void {
  const heading = title || 'TestOps Hub Conversation'
  const exportDate = formatTimestamp(new Date())

  const lines: string[] = [
    `# ${heading}`,
    '',
    `*Exported: ${exportDate}*`,
    '',
    '---',
    '',
  ]

  for (const message of messages) {
    const role = message.role === 'user' ? 'You' : 'TestOps Command'
    const ts = formatTimestamp(message.timestamp)

    lines.push(`**${role}** *(${ts})*:`)
    lines.push('')
    lines.push(message.content)

    // Include tool call summaries for assistant messages
    if (message.toolCalls && message.toolCalls.length > 0) {
      lines.push('')
      lines.push('> **Tool calls:**')
      for (const tc of message.toolCalls) {
        const status = tc.status === 'error' ? 'failed' : tc.status
        const duration = tc.duration_ms ? ` (${Math.round(tc.duration_ms)}ms)` : ''
        lines.push(`> - \`${tc.provider}/${tc.tool}\` — ${status}${duration}`)
      }
    }

    if (message.isPartial) {
      lines.push('')
      lines.push('*(Generation was stopped by user)*')
    }

    lines.push('')
    lines.push('---')
    lines.push('')
  }

  const markdown = lines.join('\n')
  const blob = new Blob([markdown], { type: 'text/markdown;charset=utf-8' })
  const url = URL.createObjectURL(blob)

  const dateStr = new Date().toISOString().slice(0, 10)
  const filename = `testops-conversation-${dateStr}.md`

  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}
